require("../../libs/backbone/backbone.ajaxq.adapter.ts");
var Handlebars = require('handlebars');

var TheView = Backbone.View.extend({
	Template: null,
	template: null,
	myDomId: null,
	domain: null,
	options: {},
	views: {},
	validations: {
	    "isEmpty": function(self, element){
	        return self.isEmpty(element);
	    },
	    "isPercentage": function(self, element){
            return self.isPercentage(element);
        },
        "checkRange": function(self, element){
            return self.checkRange(element);
        },
        "isNumber": function(self, element) {
            return self.isNumber(element);
        }
	},
	initialize: function () {
	},
	storeView: function(view, name) {
	    this.views[name] = view;
	},
	validateSingleField: function(field)
	{
	    var self = this;
        var has_error = false;

        var data_validation = field.data("validation");
        var validations = data_validation.trim().split(" ");
        $.each(validations, function(i, value) {
            if (has_error == true)
                return ;
            has_error = self.validations[value](self, field);
        });

        return has_error;
	},
    validateFields: function(fields)
    {
        var self = this;
        var has_error = false;

        $.each(fields, function() {
            var field = $(this);
            if (field.data("validation")) {
                var data_validation = field.data("validation");
                var validations = data_validation.trim().split(" ");

                $.each(validations, function(i, value) {
                    if (has_error == true)
                        return ;
                    has_error = self.validations[value](self, field);
                });
            }

        });

        return has_error;
    },
    setError: function(element, error_msg)
    {
        if((typeof element) == "string")
            element = $(element);

        var errorSpan = element.parent().find(".error-block");
        errorSpan.addClass("has-error");
        errorSpan.text(error_msg);
    },
    clearError: function(element)
    {
        if((typeof element) == "string")
            element = $(element);

        var errorSpan = element.parent().find(".error-block");
        errorSpan.removeClass("has-error");
        errorSpan.find("span.error-block").text("");
    },
    isEmpty: function(element)
    {
        element = $(element);
        var errorSpan = element.parent().find(".error-block");

        if ( element.val() == "") {
            this.setError(errorSpan, "This field can't be empty.");
            return true;
        } else {
            this.clearError(element);
            return false;
        }
    },
    isPercentage: function(element)
    {
        element = $(element);
        var errorSpan = element.parent().find(".error-block");

        if ( element.val() < 0 || element.val() > 100) {
            this.setError(errorSpan, "This field gets values ​​between 0 and 100.");
            return true;
        } else {
            this.clearError(element);
            return false;
        }
    },
    isNumber: function(element) {
        element = $(element);
        var errorSpan = element.parent().find(".error-block");

        if ( isNaN(element.val()) ) {
            this.setError(errorSpan, "Invalid data.");
            return true;
        } else {
            this.clearError(element);
            return false;
        }
    },
    checkRange: function(element) {
        element = $(element);
        var errorSpan = element.parent().find(".error-block");

        var range = element.data("range").split(",");
        var min = parseInt(range[0]);
        var max = parseInt(range[1]);
        var value = parseFloat(element.val());

        if ( value < min || value > max) {
            this.setError(errorSpan, "This field gets values ​​between " + min + " and " + max + ".");
            return true;
        } else {
            this.clearError(element);
            return false;
        }
    },
    convertToFloat: function(element) {
        var value = $(element).val();
        return isNaN(value) ? value : parseFloat(value);
    },
    convertToInt: function(element) {
        var value = $(element).val();
        return isNaN(value) ? value : parseInt(value);
    }
});

module.exports = TheView;